import React from 'react'
import PickCard from './PickCard'
import { Grid } from '@material-ui/core'
import { RoomStatus } from '../../models/ServerModels'

interface ICardPickerProps {
    possibleCards: string[]
    selectedValue: string
    roomStatus: RoomStatus
    handleValueSelected: (value: string) => void
}

export default function CardPicker({ possibleCards, selectedValue, roomStatus, handleValueSelected }: ICardPickerProps) {
    return (
        <div style={{ display: "block", width: "100%", maxWidth: "100%", boxSizing: "border-box", overflow: "visible" }}>
            <Grid container alignItems="center" justifyContent="center" style={{ overflow: "visible" }}>
                {possibleCards.map(card =>
                    <Grid key={`card-picker-grid${card}`} item style={{ overflow: "visible" }}>
                        <PickCard key={`card-picker-${card}`} value={card}
                            isSelected={selectedValue === card && roomStatus === RoomStatus.Estimating}
                            onSelected={handleValueSelected} />
                    </Grid>
                )}
            </Grid>
        </div>
    )
}
